import React, { useState, useEffect } from 'react';
import { LogD } from '../../../function/LogLapper';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import SimpleDialog from '../../atoms/Dialog/SimpleDialog';
import Typography from '@material-ui/core/Typography';
import {
  XY_CMP_GROUP_SET,
  GetXYComparisonGroupList,
  GetTrendGroupTableByItemSet,
} from '../../../function/GroupDataModel';
import XYDiagramGroupSelectPage from '../XYDiagram/XYDiagramGroupSelectPage';
import TrendGraphGroupSelectPage from '../TrendGraph/TrendGraphGroupSelectPage';
import {
  RealTimeTrendSettingModel,
  CreateDefaltRealTimeTrendSettingModel,
  GetRealTimeTrendSettingModelList,
} from './RealTimeTrendGraph';

/**ダイアログ表示モードキー */
const DialogKindKey = {
  None: 'None',
  XYComparison: 'xyComparison',
  Trend: 'trend',
} as const;

/**ダイアログ表示タイプ */
type DialgKindType = typeof DialogKindKey[keyof typeof DialogKindKey];

/**引数 */
type Props = {
  rTrendSettingList: RealTimeTrendSettingModel[];
};

const RealTimeTrendGraphButtonList: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  const { rTrendSettingList } = props;

  const [simpleDialogOpen, setSimpleDialogOpen] = React.useState(false);
  const [gropuSelectDialogOpen, setGropuSelectDialogOpen] = React.useState(false);
  const [showMessage, setShowMessage] = React.useState<string>('');

  const [dialogKind, setDialogKind] = React.useState<DialgKindType>(DialogKindKey.None);
  const [selectGroupNos, setSelectGroupNos] = React.useState<number[]>([0]);

  const buttonStyle = {
    maxWidth: '180px',
    maxHeight: '35px',
    minWidth: '180px',
    minHeight: '35px',
  };

  /**
   * グループ選択ダイアログ表示
   */
  const handleGroupSelectDialogShow = () => {
    setGropuSelectDialogOpen(true);
  };
  /**
   * グループ選択ダイアログ閉じる
   */
  const handleGroupSelectDialogClose = () => {
    setGropuSelectDialogOpen(false);
  };

  /**メッセージボックス閉じる */
  const handleSimpleDialogClose = () => {
    setSimpleDialogOpen(false);
  };

  const handleXYPageOpen = () => {
    var targets = rTrendSettingList.filter((row) => row.IsRowSelect === true);
    if (targets.length === 0) {
      //エラーメッセージ
      setShowMessage(t('RealTimeTrendGraphButtonList.項目が選択されていません', '項目が選択されていません'));
      setSimpleDialogOpen(true);
      return;
    }
    setDialogKind(DialogKindKey.XYComparison);
    GetXYComparisonGroupList().then((ret) => {
      var groupRows = ret.XY_CMP_GROUP_SETs.filter((item) => item.DSP_FLG == 1);
      var targetRows = groupRows.filter(
        (row) =>
          (row.PLC_NO_X === Number(targets[0].PLCNo) && row.SET_NO_X === Number(targets[0].SettingNo)) ||
          (row.PLC_NO_Y === Number(targets[0].PLCNo) && row.SET_NO_Y === Number(targets[0].SettingNo))
      );
      if (targetRows.length != 0) {
        var gpNos: number[] = [];
        for (var i in targetRows) {
          gpNos.push(targetRows[i].GROUP_NO);
        }
        console.debug(['targetRows,gpNos', targetRows, gpNos]);
        setSelectGroupNos(gpNos);
        handleGroupSelectDialogShow();
      } else {
        setShowMessage(
          t('RealTimeTrendGraphButtonList.項目に対するグループ登録がありません', '項目に対するグループ登録がありません')
        );
        setSimpleDialogOpen(true);
      }
      console.debug(['groupRows', groupRows]);
      console.debug(['targetRows', targetRows]);
    });
    console.debug(['表示中　リアルタイムトレンド信号リスト', rTrendSettingList]);
  };

  const handleTrandPageOpen = () => {
    var targets = rTrendSettingList.filter((row) => row.IsRowSelect === true);
    if (targets.length === 0) {
      setShowMessage(t('RealTimeTrendGraphButtonList.項目が選択されていません', '項目が選択されていません'));
      setSimpleDialogOpen(true);
      return;
    }
    setDialogKind(DialogKindKey.Trend);
    GetTrendGroupTableByItemSet().then((ret) => {
      var targetRows = ret.filter(
        (row) =>
          row.trdItemSet.PLC_NO == Number(targets[0].PLCNo) && row.trdItemSet.SET_NO === Number(targets[0].SettingNo)
      );
      if (targetRows.length != 0) {
        var gpNos: number[] = [];
        for (var i in targetRows) {
          gpNos.push(targetRows[i].trdGroupSet.GROUP_NO);
        }
        setSelectGroupNos(gpNos);
        handleGroupSelectDialogShow();
      } else {
        setShowMessage(
          t('RealTimeTrendGraphButtonList.項目に対するグループ登録がありません', '項目に対するグループ登録がありません')
        );
        setSimpleDialogOpen(true);
      }
    });
    console.debug(['表示中　リアルタイムトレンド信号リスト', rTrendSettingList]);
  };

  return (
    <Grid container>
      <Grid item xs={2}>
        <Button style={buttonStyle} variant="contained" color="primary" onClick={handleTrandPageOpen} disableElevation>
          {t('RealTimeTrendGraphButtonList.傾向管理', '傾向管理')}
        </Button>
      </Grid>
      <Grid item xs={2}>
        <Button style={buttonStyle} variant="contained" color="primary" onClick={handleXYPageOpen} disableElevation>
          {t('RealTimeTrendGraphButtonList.X-Y分布', 'X-Y分布')}
        </Button>
      </Grid>
      <SimpleDialog
        open={gropuSelectDialogOpen}
        onClose={handleGroupSelectDialogClose}
        title={t('RealTimeTrendGraphButtonList.グループ選択', 'グループ選択')}
        okText={t('RealTimeTrendGraphButtonList.閉じる', '閉じる')}
        maxWidth={'sm'}
      >
        {dialogKind == DialogKindKey.XYComparison ? (
          <XYDiagramGroupSelectPage defalutGropuNos={selectGroupNos} />
        ) : (
          <TrendGraphGroupSelectPage defalutGropuNos={selectGroupNos} />
        )}
      </SimpleDialog>
      <SimpleDialog
        open={simpleDialogOpen}
        onClose={handleSimpleDialogClose}
        title={t('RealTimeTrendGraphButtonList.グループ選択', 'グループ選択')}
        okText={t('RealTimeTrendGraphButtonList.閉じる', '閉じる')}
        maxWidth={'sm'}
      >
        <Typography>{showMessage}</Typography>
      </SimpleDialog>
    </Grid>
  );
};

export default RealTimeTrendGraphButtonList;
